import React from 'react';
import { Link } from 'react-router-dom';
import { Label, Names } from './Cut';
import { filmTypeLabel } from './theatreUtils';

export const UpNext = ({ films, onPick, currentIndex, total }) => (
  <div className="px-5 py-6" data-testid="film-up-next">
    <div className="flex items-baseline justify-between">
      <Label>Up next</Label>
      {total > 1 && <span className="th-caption">{currentIndex + 1} of {total}</span>}
    </div>
    <hr className="th-rule my-4" />
    <ul className="space-y-1">
      {films.map((film, i) => (
        <li key={film.id} className="th-rise" style={{ animationDelay: `${i * 50}ms` }}>
          <button type="button" onClick={() => onPick(film.playlistIndex)} className="w-full flex items-center gap-4 py-2.5 text-left group" data-testid={`film-up-next-${film.id}`}>
            <span className="th-frame th-cut th-cut-sm w-24 flex-shrink-0 group-hover:is-active">
              <span className="th-cut th-cut-sm th-solid block aspect-video overflow-hidden">
                {film.thumbnail_url && <img src={film.thumbnail_url} alt="" className="w-full h-full object-cover" loading="lazy" decoding="async" />}
              </span>
            </span>
            <span className="min-w-0 flex-1">
              <span className="th-label text-[9px] block truncate" style={{ color: 'var(--th-faint)' }}>{filmTypeLabel(film)}</span>
              <Names text={film.title} className="text-lg font-light tracking-[0.06em] block truncate" />
              {film.subtitle && <span className="th-caption block truncate">{film.subtitle}</span>}
            </span>
          </button>
        </li>
      ))}
    </ul>
    <hr className="th-rule my-6" />
    <div className="space-y-3">
      <Link to="/crystal-difference" className="th-frame th-cut th-cut-sm block" data-testid="film-crystal-difference-link">
        <span className="th-cut th-cut-sm th-solid th-btn th-btn-ghost">Why us — the Crystal difference</span>
      </Link>
      <a href="/inquire" target="_blank" rel="noopener noreferrer" className="th-btn th-btn-text" data-testid="film-inquire-link">Inquire</a>
      <div className="grid grid-cols-3 gap-1 pt-2">
        {[['/photo', 'Photo'], ['/services', 'Services'], ['/about', 'About']].map(([to, label]) => (
          <Link key={to} to={to} className="block py-2 text-center th-label text-[10px]" style={{ color: 'var(--th-faint)' }}>{label}</Link>
        ))}
      </div>
    </div>
  </div>
);
